<div class="cm-skeleton-page">
  <!-- Header skeleton -->
  <div class="cm-skeleton-page-header" role="status" aria-live="polite" aria-label="Loading page details">
    <span class="sr-only">Loading information, please wait...</span>
    <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 40px; height: 40px;"></div>
    <div class="cm-skeleton-page-header-content">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 150px;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 250px;"></div>
      <div class="cm-skeleton-page-header-chips">
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 60px; height: 24px; border-radius: 12px;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 110px; height: 24px; border-radius: 12px;"></div>
      </div>
    </div>
    <div class="cm-skeleton-page-header-actions">
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 40px; height: 40px; border-radius: 4px;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 140px; height: 40px; border-radius: 4px;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 160px; height: 40px; border-radius: 4px;"></div>
    </div>
  </div>

  <!-- Page content skeleton -->
  <div class="cm-skeleton-page-content">
    <!-- Alert card skeleton -->
    <div class="cm-skeleton-page-card">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 60%;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 80%;"></div>
    </div>

    <!-- Main content cards (7 cards) -->
    <div class="cm-skeleton-page-main">
      @for (item of [1, 2, 3, 4, 5, 6, 7]; track item) {
        <div class="cm-skeleton-page-card">
          <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 150px;"></div>
          <div class="cm-skeleton-page-card-content">
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 100%;"></div>
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 100%;"></div>
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 80%;"></div>
          </div>
        </div>
      }
    </div>

    <!-- Sidebar cards (2 cards) -->
    <div class="cm-skeleton-page-sidebar">
      @for (item of [1, 2]; track item) {
        <div class="cm-skeleton-page-card">
          <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 120px;"></div>
          <div class="cm-skeleton-page-card-sidebar-content">
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 100%;"></div>
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 100%;"></div>
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 90%;"></div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
